/*!
 * doTERRA CRM
 * http://www.doterra.com
 *
 * Copyright 2019 doTERRA Holdings, LLC
 * All Rights Reserved
 */
import './containers/profile-payments';
import './containers/order-payment-panel';
import './containers/enrollment-payments';
import './containers/order-review-payments';
import './containers/order-confirmation-panel';
import './containers/express-checkout-payments';
import './containers/rwp-favorite-links';
import './containers/rwp-links-homepage';
// window.setServiceItemOnlyOrder = function(resp) {
//     return crmShippingPanel.setServiceItemOnlyOrder(resp);
// }
